import MatchAnalysis from "../components/MatchAnalysis";

const MatchAnalysisPage = () => {
    return (
        <div className="analysis-page">
            <MatchAnalysis />
        </div>
    );
};

export default MatchAnalysisPage;